import { render, staticRenderFns } from "./detailWorkList.vue?vue&type=template&id=6f42ad88&"
import script from "./detailWorkList.vue?vue&type=script&lang=js&"
export * from "./detailWorkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports